import { ComplTrxImportEditForm } from "src/app/features/CompletionTransactionImport/components/forms/ComplTrxImportEditForm";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";

export const ComplTrxImportEditFormPage = () => {
    const hasAccess = canAccess(ResourceName.COMPL_TRX_IMPORT, "canRead");

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.complTrxImportEditFormPage" />
                    </FPageHeader>
                    <FPageContent>
                        <ComplTrxImportEditForm />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
